/**
 * The HR permission codes C11 adds — the skills and certifications register.
 *
 * Named once here so a renamed code is a compile error rather than a button that
 * silently never renders. Every string is exactly what `internal/hr/skill.go`
 * registers and what `/auth/me` returns.
 *
 * **`skillGrant` is not `skillManage`, and the split is the point.** Editing the
 * catalogue — deciding that "Confined space entry" is a statutory competency this
 * company recognises — is a policy act performed by HR. *Granting* it to a named
 * person is an evidentiary one performed by whoever saw the certificate. A
 * planner who could do both could invent a competency and award it to themselves
 * on the morning they needed it, which is the whole reason a statutory skill is
 * tracked at all. So the register screen renders its editing affordances on
 * `skillManage` and a person's grant panel renders its own on `skillGrant`, and
 * neither infers the other.
 */

export const HR_C11_PERMISSIONS = {
  skillRead: 'hr.skill.read',
  /** Edit the catalogue: what competencies exist, and which are statutory. */
  skillManage: 'hr.skill.manage',
  /** Award or close a named person's holding of one. Deliberately separate. */
  skillGrant: 'hr.skill.grant',
} as const

export type HrC11Permission = (typeof HR_C11_PERMISSIONS)[keyof typeof HR_C11_PERMISSIONS]
